    import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Col, Row, Container, Image } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";

import Card from "../../components/Card/index";
import Title from "../../components/Title";
import Input from "../../components/Input/index";
import Button from "../../components/Button/index";
import ErrorMessage from "../../components/ErrorMessage";

import { TitlePage } from "./styles"

//Assets
import Logo from "../../assets/img/logo.svg";

const NewPasswordPage = () => {
    const [error, setError] = useState(false);
    
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }

    const history = useHistory();
    const query = useQuery();

    useEffect(() => {
        document.body.classList.add("body-login");

        return () => {
        document.body.classList.remove("body-login");
        };
    }, []);

    const formValidationWithYup = Yup.object().shape({
        password: Yup.string().required(),
        repeatPassword: Yup.string().required()
    });

    const searchForErrors = (errors: any) => {
        if(errors !== {}){
            setError(true);
        } else {
            setError(false);
        }
    }

    return (
        <Container className="vh-100 d-flex align-items-center justify-content-center">
            <Row>
                <Col lg="12">
                    <Card>
                        <Container>
                            <Row>
                                <Col xl="12" className="text-center  pt-4">
                                    <Image src={Logo} style={{ height: 45 }} />
                                </Col>
                                
                                <Col xl="12" className="text-center pt-5 ">
                                    <TitlePage>Nova senha</TitlePage>
                                </Col>
                                <Formik
                                    initialValues={{
                                        password: "",
                                        repeatPassword: ""
                                    }}
                                    validationSchema={formValidationWithYup}
                                    onSubmit={async (values) => {
                                        if(values.repeatPassword === values.password){
                                            try {
                                                const {data} = await axios.post("https://api.100pay.org/password/reset", {
                                                    password: values.password,
                                                    password_confirmation: values.repeatPassword,
                                                    token: query.get("token")
                                                });

                                                history.push("auth/login");
                                            } catch (error) {
                                                setError(true);
                                            }
                                        } else {
                                            setError(true);
                                        }
                                    }}
                                >
                                    {({errors}) => {
                                        return(
                                            <Form style={{width: "100%"}}>
                                                <Col xl="12" className=" pt-3 ">
                                                    <Title>Digite a nova senha</Title>
                                                    <Field 
                                                        id="password" 
                                                        name="password" 
                                                        type="password" 
                                                        as={Input}
                                                        style={{borderColor: errors.password && error ? "red": null}}    
                                                    />
                                                </Col>

                                                <Col xl="12" className=" pt-3 ">
                                                    <Title>Confirme a nova senha</Title>
                                                    <Field 
                                                        id="repeatPassword" 
                                                        name="repeatPassword" 
                                                        type="password" 
                                                        as={Input}
                                                        style={{borderColor: errors.repeatPassword && error ? "red": null}}    
                                                    />
                                                </Col>

                                                <Col xl="12" className=" pt-5">
                                                    {
                                                        errors === {} && error === true ? 
                                                            <ErrorMessage>
                                                                Falha ao atualizar senha
                                                            </ErrorMessage> : null
                                                    }
                                                    <Button 
                                                        type="submit" 
                                                        onClick={() => {
                                                            searchForErrors(errors);
                                                        }}
                                                    >
                                                        Confirmar
                                                    </Button>
                                                </Col>
                                            </Form>
                                        )
                                    }}
                                </Formik>

                            </Row>
                        </Container>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default NewPasswordPage;
